import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NavaidModel } from 'src/app/models/navaid';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { PointsService } from 'src/app/services/points.service';
import { DuplicationCheckComponent } from '../duplication-check/duplication-check.component';

@Component({
  selector: 'app-duplication-check-options',
  templateUrl: './duplication-check-options.component.html',
  styleUrls: ['../../app.component.scss'],
  standalone: false
})
export class DuplicationCheckOptionsComponent implements OnInit {

  optionsToDisplay = ["Selected Navaids","All Navaids"];
  constructor(public bsModalRef : BsModalRef,
    private modalService : BsModalService,
    private modalControl: ModalControlService,
    private pointsController: PointsService,
    ) { }

  ngOnInit(): void {
  }
  selectOption(option: string){
    let navaidsToCheck:NavaidModel[] = []
    if(option == this.optionsToDisplay[0]){
      navaidsToCheck = this.pointsController.getSelectedNavaids();
    }
    else{
      navaidsToCheck = this.pointsController.getAllNavaidsFromLayers();
    }
    this.bsModalRef.hide();
    DuplicationCheckComponent.showDuplicates(navaidsToCheck,this.modalService,this.modalControl);
  }
  cancel(){
    this.bsModalRef.hide();
  }

}
